import { Zap } from "lucide-react";
import { useTerminal } from "@/lib/terminal";

export const QuickAmount = () => {
  const { quickAmount, setQuickAmount } = useTerminal();
  return (
    <label className="flex items-center gap-1.5 px-2 py-1 rounded border border-[#00E676]/30 bg-[#00E676]/5 text-xs font-mono focus-within:border-[#00E676] transition-colors" title="Hızlı alım miktarı (ETH)">
      <Zap className="w-3.5 h-3.5 text-[#00E676]" />
      <input
        data-testid="quick-buy-amount-input"
        type="number" step="0.001" min="0"
        value={quickAmount}
        onChange={(e) => setQuickAmount(e.target.value === "" ? "" : Number(e.target.value))}
        className="w-16 bg-transparent outline-none text-slate-100"
      />
      <span className="text-slate-500">Ξ</span>
    </label>
  );
};
